/**
 * Functionality
 */

import detectTabbing from './lib/detect-tabbing'
detectTabbing()

import externalLinks from './lib/external-links'
externalLinks()

import subLinks from './lib/sub-links'
subLinks()

import vhCheck from 'vh-check'
vhCheck()

import SwidgetObserver from './lib/swidget-observer'
new SwidgetObserver()

/**
 * Components
 */

import './components/RichText'
import './components/UseColor'
import './components/ReadMore'
import './components/VideoEmbed'
import './components/MediaLoad'
import './components/CollectionItems'
import './components/HomeSlider'
import './components/Slider'
import './components/NavigationDesktop'
import './components/NavigationMobile'
import './components/PageModules'
import './components/Hours'
import './components/PlayPause'
import './components/TextBalancer'
import './components/Widont'
import './components/Colcade'
import './components/Footnotes'
import './components/Gallery'
import './components/SearchInput'
import './components/SearchModal'
